module.exports = {"pagination":{"ListCertificates":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"CertificateSummaryList"}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/acm-2015-12-08.paginators.json
// module id = 260
// module chunks = 0